import hidden from './hidden.json';
import title from './title.json';

export default { hidden, title };
